import Header from "./Header";
import Footer from "./Footer";
import {useEffect, useState} from "react";
import {authenticate, authenticateGoogle, getJwtRole, isUserLoggedIn} from "../service/AuthService";
import {useNavigate} from "react-router-dom";
import {green, red, ftAccessToken, ftRefreshToken} from "../constants/Constants";
import Loading from "./Loading";
import {Eye, EyeOff} from "lucide-react";
import {FcGoogle} from "react-icons/fc";
import {properties} from "../properties";

function LogIn() {

    const navigate = useNavigate();

    let [role, setRole] = useState(getJwtRole());
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(true);

    const [errorSuccessMessage, setErrorSuccessMessage] = useState(null);
    const [errorSuccessOpacity, setErrorSuccessOpacity] = useState(1);
    const [hidePassword, setHidePassword] = useState(true);

    function addErrorSuccess(message, color) {
        if (window.innerWidth >= 991 || color === green) {
            setErrorSuccessMessage(
                <div className="success-or-error-notifications" style={{color: color, opacity: errorSuccessOpacity}}>
                    {message}
                </div>
            );
            setErrorSuccessOpacity(1);

            setTimeout(() => {
                setErrorSuccessOpacity(0);
            }, 2000);

            setTimeout(() => {
                setErrorSuccessOpacity(1);
                setErrorSuccessMessage(null);
            }, 3000);
        } else {
            window.alert(message);
        }
    }

    useEffect(() => {
        if (isUserLoggedIn()) {
            navigate("/");
        }
    }, []);

    const handleSubmit = async (event) => {
        event.preventDefault();
        setLoading(true);
        try {
            authenticate(email, password)
                .then(loginResponse => {
                    if (loginResponse === 500) {
                        addErrorSuccess("Could not log in", red);
                        setLoading(false);
                    } else {
                        localStorage.setItem(ftAccessToken, JSON.stringify(loginResponse.access_token));
                        localStorage.setItem(ftRefreshToken, JSON.stringify(loginResponse.refresh_token));
                        role = getJwtRole();
                        setRole(role);
                        // role === 'ROLE_ADMIN' ? navigate("/admin") : navigate("/account");
                        navigate("/account");
                        setLoading(false);
                    }
                })
                .catch(error => {
                    console.error("Error logging in:", error);
                    addErrorSuccess("Could not log in", red);
                    setLoading(false);
                });

        } catch (error) {
            console.error('Login failed:', error);
            setLoading(false);
        }
    };

    const loginForm = (
        <div className="dashboard-table-wrapper">
            <form onSubmit={handleSubmit} className={"fade-in center"} style={{position: "relative"}}>
                {errorSuccessMessage && (
                    <div className="success-or-error-login"
                         style={{color: errorSuccessMessage.props.style.color, opacity: errorSuccessOpacity}}>
                        {errorSuccessMessage.props.children}
                    </div>
                )}
                <input className={"research-form-input contact-form-input"}
                       required
                       type={"email"}
                       placeholder={"Email"}
                       value={email}
                       onChange={(e) => setEmail(e.target.value)}
                />
                <div style={{position: "relative"}}>
                    <input className={"research-form-input contact-form-input"}
                           required
                           type={hidePassword ? "password" : "text"}
                           placeholder={"Password"}
                           value={password}
                           onChange={(e) => setPassword(e.target.value)}
                    />
                    <div className={'eye'} onClick={() => setHidePassword(!hidePassword)}>
                        {hidePassword ?
                            <EyeOff size={20}/>
                            :
                            <Eye size={20}/>
                        }
                    </div>
                </div>
                <div className={"send-wrapper mobile-margin-bottom-0"}>
                    <button type={"submit"} className="submit">Log In</button>
                </div>
            </form>
        </div>
    );

    // useEffect(() => {
    //     setLoading(true);
    //
    //     const waitForGoogle = () => {
    //         if (window.google && window.google.accounts && window.google.accounts.id) {
    //             google.accounts.id.initialize({
    //                 client_id: properties.google.clientId,
    //                 callback: handleCredentialResponse,
    //             });
    //             setLoading(false); // ✅ once actually ready
    //         } else {
    //             setTimeout(waitForGoogle, 100); // check again in 100ms
    //         }
    //     };
    //
    //     waitForGoogle();
    // }, []);
    //
    //
    // const handleCredentialResponse = (response) => {
    //     const idToken = response.credential;
    //     setLoading(true);
    //     fetch("/auth/google", {
    //         method: "POST",
    //         headers: { "Content-Type": "application/json" },
    //         body: JSON.stringify({ idToken }),
    //     })
    //         .then((res) => res.json())
    //         .then((data) => {
    //             console.log("Logged in:", data);
    //         })
    //         .catch((err) => console.error("Login failed", err));
    // };
    //
    // const handleGoogleSignIn = () => {
    //     /* global google */
    //     if (window.google) {
    //         google.accounts.oauth2.initCodeClient({
    //             client_id: properties.google.clientId,
    //             scope: "openid email profile",
    //             ux_mode: "popup",
    //             callback: (response) => {
    //                 console.log(response);
    //             },
    //         }).requestCode(); // triggers Google's popup
    //     } else {
    //         console.error("Google API not loaded");
    //     }
    // };

    useEffect(() => {
        setLoading(true);

        let attempts = 0;
        const waitForGoogle = () => {
            if (window.google?.accounts?.oauth2) {
                setLoading(false);
            } else if (attempts < 100) { // ~10 seconds max
                attempts++;
                setTimeout(waitForGoogle, 100);
            } else {
                console.error("Google API failed to load");
                setLoading(false); // give up
            }
        };

        waitForGoogle();
    }, []);


    const handleGoogleSignIn = () => {
        /* global google */
        if (window.google && window.google.accounts && window.google.accounts.oauth2) {
            const client = google.accounts.oauth2.initCodeClient({
                client_id: properties.google.clientId,
                scope: "openid email profile",
                ux_mode: "popup",
                callback: (response) => {
                    console.log("Google OAuth response:", response); // contains { code, scope, ... }
                    setLoading(true);
                    try {
                        authenticateGoogle(response)
                            .then(loginResponse => {
                                if (loginResponse === 500) {
                                    addErrorSuccess("Could not log in", red);
                                    setLoading(false);
                                } else {
                                    localStorage.setItem(ftAccessToken, JSON.stringify(loginResponse.access_token));
                                    localStorage.setItem(ftRefreshToken, JSON.stringify(loginResponse.refresh_token));
                                    role = getJwtRole();
                                    setRole(role);
                                    // role === 'ROLE_ADMIN' ? navigate("/admin") : navigate("/account");
                                    navigate("/account");
                                    setLoading(false);
                                }
                            })
                            .catch(error => {
                                console.error("Error logging in:", error);
                                addErrorSuccess("Could not log in", red);
                                setLoading(false);
                            });

                    } catch (error) {
                        console.error('Login failed:', error);
                        setLoading(false);
                    }
                },
            });

            client.requestCode(); // opens Google popup
        } else {
            console.error("Google API not loaded yet");
        }
    };


    return (
        <div className={"login page"}>
            <Header page={"login"}/>
            <div className={"education-title center"}>Hello!</div>
            <div className={"content body"}>
                <div className={"section enclosed"}>
                    {loading ?
                        <Loading/>
                        :
                        <div className={"half-section login-form"}>
                            <>
                                <div className={"section-subheading center"} style={{marginBottom: '1rem'}}>Log In</div>
                                {loginForm}
                                <div className={"login-links"}>
                                    <div className={"login-link"}>
                                        <span>New to 42 Degrees? Click </span>
                                        <a href={"/signup"} className={"click-here"}>here</a>
                                        <span> to sign up!</span>
                                    </div>
                                    <div className={"login-link"}>
                                        <a href={"/forgot-password"} className={"click-here"}>Forgot your password?</a>
                                    </div>
                                </div>
                                <div className={"or-wrapper"}>
                                    <div className={"or-line"}></div>
                                    <div className={"or-text"}>or</div>
                                    <div className={"or-line"}></div>
                                </div>
                                <div className={"sign-in-google"} onClick={handleGoogleSignIn}>
                                    <div className={"google-logo"}><FcGoogle size={"100%"}/></div>
                                    <div className={"google-text"}>Sign in with Google</div>
                                </div>
                            </>
                        </div>
                    }
                </div>
            </div>
            <Footer/>
        </div>
    )
}

export default LogIn;